import lodash from 'lodash';
import moment from 'moment';
import { formatDateOnly, formatDateTime } from './delegationAuditLogTemplates';

const DOA_SIGNATURE_TYPES = {
    PI_START: 'PI_START',
    PI_END: 'PI_END',
    STAFF_START: 'STAFF_START',
};

/**
 * @typedef {import('./DelegationAuditLog').DOA} DOA
 */


const signatureTestamentTypeLabelLookup = {
    PI_START: 'Principal Investigator Testament',
    PI_END: 'Principal Investigator Testament',
    STAFF_START: 'Staff Testament'
};

/**
 * 
 * @param {Object} delegation 
 * @returns {String}
 */
export const formatSignatureManifestationHeader = delegation => {
    const userDisplayName = delegation.user.displayName;
    const userRole = delegation.role;
    const now = moment().toISOString();
    const startDate = formatDateOnly(delegation.startDate);
    const endDate = delegation.endDate ? `to ${formatDateOnly(delegation.endDate)}` : `- active as of ${formatDateOnly(now)}`;
    return `${userDisplayName} as ${userRole} from ${startDate} ${endDate}`;
};

/**
 * 
 * @param {Object} delegationSignature 
 * @param {String} timezoneOffset 
 * @returns {Array<String>}
 */
export const formatDelegationSignatureTableRow = (delegationSignature, timezoneOffset) => {
    const signature = delegationSignature.signature;
    const signatureType = delegationSignature.signatureType;
    const signingUser = signature.user;

    return [
        signingUser.displayName,
        signingUser.emailAddress,
        formatDateTime(signature.createdAt, timezoneOffset),
        signatureTestamentTypeLabelLookup[signatureType]
    ];
};

/**
 * 
 * @param {Object} delegation 
 * @param {DOA} DOA 
 * @returns {Array<String>}
 */
export const formatDelegationTableRow = (delegation, DOA) => {
    const delegationUserAndRole = `${delegation.user.displayName}\n${delegation.role}`;
    const delegationBody = [
        delegationUserAndRole,
        `${getTaskIndexList(delegation, DOA)}`,
        `${getDateOnly(delegation.startDate)}`,
        `${getSignatureDateOfType(delegation, DOA_SIGNATURE_TYPES.PI_START)}`,
        `${getSignatureDateOfType(delegation, DOA_SIGNATURE_TYPES.STAFF_START)}`,
        `${getDateOnly(delegation.endDate)}`,
        `${getSignatureDateOfType(delegation, DOA_SIGNATURE_TYPES.PI_END)}`,
    ];
    return delegationBody;
};

/**
 * Gets the appropriate task index values for the 
 * tasks associated with the delegation.
 * @param {Object} delegation 
 * @param {DOA} DOA 
 */
const getTaskIndexList = (delegation, DOA) => 
    lodash.map(delegation.taskIds, taskId => DOA.studyTasks[taskId].taskIndex);

/**
 * 
 * @param {Date} date 
 */
const getDateOnly = date => 
    date ? formatDateOnly(date) : '';

const getSignatureDateOfType = (delegation, signatureType) => {
    const delegationSignature = getMostRecentSignatureOfType(delegation, signatureType);
    const signatureDate = lodash.get(delegationSignature, 'signature.createdAt');
    return getDateOnly(signatureDate);
};

const getMostRecentSignatureOfType = (delegation, signatureType) =>
    lodash.find(delegation.signatures, ['signatureType', signatureType]);

